if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      if (this.hidden) {
        this.initLazySection();
      } else {
        window.initLazyScript(this, this.initLazySection.bind(this));
      }
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.variantInventory = this.getVariantInventory();

      // Bind to on:variant:change event for this product
      const variantPicker = this.closest('.product-info').querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      // Init
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );
    }

    /**
     * Gets the inventory data for all product variants
     * @returns {?object}
     */
    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.filter(
          (variant) => variant.id === evt.detail.variant.id
        )[0];
        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy
        );
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    /**
     *
     * Updates the inventory notice
     * @param {number} count - the inventory quantity available
     * @param {boolean} available - whether current variant is available
     * @param {string} inventoryPolicy - whether product continues selling when out of stock
     */
    updateInventory(count, available, inventoryPolicy) {
      if (count === 0 && !available && this.hidden) {
        return;
      }

      let inventoryLevel;

      if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      if (((this.dataset.showNotice === 'always'
        || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low')))
        && !(inventoryLevel === 'backordered' && this.dataset.showNoStockBackordered === 'false'))) {
        this.hidden = false;

        // Set the inventory level data attribute
        this.setAttribute('data-inventory-level', inventoryLevel);

        // Determine whether to show the count or not
        if (inventoryLevel === 'backordered') {
          this.inventoryNotice.innerText = 'Lieferzeit: ca. 10 bis 14 Werktage'
          ;
      const noticeMap = {
  in_stock: this.dataset.textNormal,
  normal: this.dataset.textNormal,
  low: this.dataset.textLow,
  very_low: this.dataset.textVeryLow,
  backordered: this.dataset.textNoStockBackordered,
  none: this.dataset.textNoStock
};

if (this.inventoryNotice) {
this.inventoryNotice.innerHTML = (noticeMap[inventoryLevel] || '').trim();}
        }

        // Update urgency message if needed
        if (this.urgencyMessage) {
          if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === 'backordered') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStockBackordered;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          } else if (inventoryLevel === 'none') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStock;
          }
        }

        // Update the bar indicator
        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;

          let newWidth;
          if ((count >= this.dataset.scale || inventoryLevel === 'in_stock') && inventoryLevel !== 'backordered') {
            newWidth = 100;
          } else {
            newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
          }
          this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
        }
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
/* --- Koi-Area Fix: Inventory-Status bei Variantenwechsel aktualisieren --- */
(() => {
  const CE = customElements.get('product-inventory');
  if (!CE) return;

  // Nicht doppelt patchen
  if (CE.prototype.__kaInventoryPatched) return;
  CE.prototype.__kaInventoryPatched = true;

  CE.prototype.__kaUpdateFromVariantId = function (variantId) {
    try {
      if (!variantId) return;

      const jsonEl = this.querySelector('script[type="application/json"]');
      if (!jsonEl) return;

      const variants = JSON.parse(jsonEl.textContent || '[]');
      const v = variants.find(x => String(x.id) === String(variantId));
      if (!v) return;

      const qty = Number(v.inventory_quantity ?? 0);
      const policy = v.inventory_policy;
      const available = !!v.available;

      const low = Number(this.dataset.thresholdLow ?? 0);
      const veryLow = Number(this.dataset.thresholdVeryLow ?? 0);

      let level = 'none';

      // Backorder (verkaufbar trotz 0 Bestand)
      if (policy === 'continue' && qty <= 0) {
        level = 'backordered';
      } else if (!available) {
        level = 'none';
      } else if (veryLow && qty <= veryLow) {
        level = 'very_low';
      } else if (low && qty <= low) {
        level = 'low';
      } else {
        level = 'in_stock';
      }

      // Attribut setzen (damit dein CSS greift)
      this.setAttribute('data-inventory-level', level);

      // Texte aus data-Attributen holen (kommen aus product-inventory.liquid)
      const statusEl = this.querySelector('.product-inventory__status');
      const urgencyEl = this.querySelector('.product-inventory__urgency');

      const texts = {
        in_stock: this.dataset.textNormal,
        normal: this.dataset.textNormal,
        low: this.dataset.textLow,
        very_low: this.dataset.textVeryLow,
        none: this.dataset.textNoStock,
        backordered: this.dataset.textNoStockBackordered
      };

      if (statusEl) statusEl.textContent = texts[level] || '';

      // Urgency nur bei low / very_low
      if (urgencyEl) {
        urgencyEl.textContent =
          (level === 'low' || level === 'very_low') ? (this.dataset.textUrgency || '') : '';
      }
    } catch (e) {
      console.warn('Inventory patch error', e);
    }
  };

  const refresh = () => {
    document.querySelectorAll('product-inventory').forEach(el => {
      const form = el.closest('section')?.querySelector('form[action*="/cart/add"]')
        || document.querySelector('form[action*="/cart/add"]');

      const idInput = form?.querySelector('input[name="id"]');
      const variantId = idInput?.value || new URLSearchParams(location.search).get('variant');

      el.__kaUpdateFromVariantId(variantId);
    });
  };

  // Trigger bei Variantenwechsel
  document.addEventListener('change', (e) => {
    if (e.target && e.target.matches('form[action*="/cart/add"] input[name="id"]')) {
      refresh();
    }
  });

  // Falls dein Theme eigene Events nutzt (sicher ist sicher)
  document.addEventListener('variant:change', refresh);
  document.addEventListener('variant-change', refresh);

  // Beim Laden einmal initial korrekt setzen
  document.addEventListener('DOMContentLoaded', refresh);
})();